<template>
  <span>
    <b-container fluid>
      <b-card title="Reçus fiscaux">
        <b-row class="justify-content-md-center text-center">
          <b-col sm="auto">
            <p class="font-weight-bold">Assistant d'export</p>
            <b-button
              v-if="!assistantOn"
              size="lg"
              variant="secondary"
              @click="onToggleAssistant()"
              >Démarrer
            </b-button>
            <b-button
              v-else
              size="lg"
              variant="danger"
              @click="onToggleAssistant()"
              >Fermer</b-button
            >
          </b-col>
        </b-row>
        <hr class="mt-5" />
        <span v-if="!assistantOn">
          <b-row class="justify-content-md-center text-center">
            <b-col sm="auto">
              <h4 class="font-weight-bold">Historique</h4>
            </b-col>
          </b-row>
          <div
            v-for="paramRecuFiscal in paramRecuFiscaux"
            :key="paramRecuFiscal.id"
          >
            <span v-if="paramRecuFiscal.recuFiscaux.length > 0">
              <div class="accordion" role="tablist">
                <b-card class="mb-1" no-body>
                  <b-card-header class="p-1" header-tag="header" role="tab">
                    <b-button
                      v-b-toggle="'accordion-' + paramRecuFiscal.year"
                      block
                      variant="secondary"
                    >
                      <h5>{{ paramRecuFiscal.year }}</h5>
                    </b-button>
                  </b-card-header>

                  <b-collapse
                    :id="'accordion-' + paramRecuFiscal.year"
                    role="tabpanel"
                  >
                    <!--  TODO table doesnt display correctly-->
                    <b-card-body>
                      <b-table
                        :fields="tableColumns"
                        :items="paramRecuFiscal.recuFiscaux"
                        stacked="md"
                        striped
                      >
                        <template v-slot:emailSent="data">
                          <font-awesome-icon
                            v-if="data.item.emailSent"
                            :style="{ color: 'green' }"
                            icon="check"
                          />
                          <font-awesome-icon
                            v-else
                            :style="{ color: 'red' }"
                            icon="times"
                            size="lg"
                          />
                        </template>
                        <template v-slot:cell(fileName)="data">
                          <label
                            class="pointer-telechargement"
                            @click="telechargerRecuFiscal(data.item)"
                          >
                            {{ data.item.fileName }}
                          </label>
                        </template>
                      </b-table>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </span>
          </div>
        </span>
        <assistant-export
          v-if="assistantOn"
          @close="onToggleAssistant()"
        ></assistant-export>
      </b-card>
    </b-container>
  </span>
</template>

<script>
import AssistantExport from "../components/recuFiscaux/AssistantExport";
import ApiService from "../service/apiService";

export default {
  name: "RecusFiscaux",
  components: {
    assistantExport: AssistantExport,
  },
  data() {
    return {
      paramRecuFiscaux: [],
      assistantOn: false,
      tableColumns: [
        {
          key: "nom",
          label: "Nom",
          sortable: true,
        },
        {
          key: "prenom",
          label: "Prénom",
          sortable: true,
        },
        {
          key: "adresse",
          label: "Adresse",
          sortable: true,
        },
        {
          key: "montant",
          label: "Montant",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "dateDon",
          label: "Date don",
          sortable: false,
        },
        {
          key: "modePaiement",
          label: "Mode paiement",
          sortable: false,
        },
        {
          key: "emailSent",
          label: "Email envoyé",
          sortable: true,
        },
        {
          key: "fileName",
          label: "Fichier",
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    this.findRecusFiscaux();
  },
  methods: {
    async findRecusFiscaux() {
      var resp = await ApiService.recuFiscal.findAllRecusFiscauxParam();
      this.paramRecuFiscaux = resp.data;
    },
    async telechargerRecuFiscal(recuFiscal) {
      var res = await ApiService.recuFiscal.telechargerRecuFiscal(
        recuFiscal.id
      );
      if (res) {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", recuFiscal.fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
      }
    },
    onToggleAssistant() {
      this.assistantOn = !this.assistantOn;
      if (!this.assistantOn) {
        this.findRecusFiscaux();
      }
    },
  },
};
</script>

<style></style>
